import React from "react"
import PropTypes from "prop-types"
import injectSheet from "react-jss"
import cn from "classnames"
import products, { getProduct } from "@/helpers/products"
import { Icon } from "@xingternal/360-components"

const sizes = {
  small: {
    width: 16,
    height: 18,
    icon: 8,
  },
  big: {
    width: 48,
    height: 54,
    icon: 24,
    marginBottom: 12,
  },
}

const hexagonSvgBackground = (product) => {
  const encodedColor = encodeURIComponent(getProduct(product).color)

  return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='32' viewBox='0 0 28 32'%3E%3Cpath fill='${encodedColor}' fill-rule='evenodd' d='M26.1334211%2C25.4024808 L15.8667435%2C31.4867273 C14.711697%2C32.1710909 13.2886323%2C32.1710909 12.1332565%2C31.4867273 L1.86657886%2C25.4024808 C0.711532356%2C24.7181172 0%2C23.4531427 0%2C22.0840775 L0%2C9.91592254 C0%2C8.54685726 0.711532356%2C7.28188284 1.86657886%2C6.59751918 L12.1332565%2C0.513272747 C13.2886323%2C-0.171090916 14.711697%2C-0.171090916 15.8667435%2C0.513272747 L26.1334211%2C6.59751918 C27.2884676%2C7.28188284 28%2C8.54685726 28%2C9.91592254 L28%2C22.0840775 C28%2C23.4531427 27.2884676%2C24.7181172 26.1334211%2C25.4024808'/%3E%3C/svg%3E")`
}

const styles = {
  container: {
    composes: "inline-flex justify-center align-items-center",
    width: ({ size }) => sizes[size].width,
    height: ({ size }) => sizes[size].height,
    marginBottom: ({ size }) => sizes[size].marginBottom,
    lineHeight: 0, // fixes some vertical extra space
    backgroundImage: ({ product }) => hexagonSvgBackground(product),
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
  },
}

const LicenseIcon = ({ classes, className, product, size }) => (
  <div className={cn(classes.container, className)}>
    <Icon
      name={getProduct(product).icon}
      size={sizes[size].icon}
      color="white"
    />
  </div>
)

LicenseIcon.propTypes = {
  /** ebp, xjm, xtm, xtp or 360 */
  product: PropTypes.oneOf(Object.keys(products)),
  size: PropTypes.oneOf(["small", "big"]),
}

LicenseIcon.defaultProps = {
  product: "360",
  size: "small",
}

export const StyledLicenseIcon = injectSheet(styles)(LicenseIcon)
export default LicenseIcon
